import {Localizer} from "../../../../infrastructure/localization/localizer";
import {debounce} from "lodash";

type ReactTablePaginationCountProps<T> = {
    pageIndex: number
    pageCount: number
    setPageindex: (pageIndex: number) => void
    debounceDelay?: number;
}

export const ReactTablePaginationCount = <T, >({debounceDelay = 1000, pageIndex, pageCount, setPageindex}: ReactTablePaginationCountProps<T>) => {
    return (
        <div className="d-flex margin-right-s align-items-center">
            <div className="margin-right-s">
                <strong>{Localizer.global_page()}</strong>
                 <input
                    type="number"
                    min="1"
                    max={pageCount}
                    defaultValue={pageIndex}
                    onChange={debounce(e => {
                        const page = e.target.value ? Number(e.target.value) - 1 : 0;
                        if (page >= pageCount) return;
                        setPageindex(page)
                    }, debounceDelay)}
                    className="border dashboard-card-border-radius rounded margin-left-s margin-right-s"
                />
                <strong>{`${Localizer.global_af()} ${pageCount}`}</strong>
            </div>
        </div>
    )
}
